import store from "@/store";

function install(Vue, options = {}) {
  Vue.directive(options.name || "auth", {
    // 指令定义对象的钩子函数inserted
    inserted(el, binding) {
      if (!binding.value.includes(store.getters.authRole)) {
        el.parentNode && el.parentNode.removeChild(el);
      }
    }
  });
}

export default { install };
